import { Component, Input, OnInit } from '@angular/core';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story-post',
  templateUrl: './cooking-story-post.component.html',
  styleUrls: ['./cooking-story-post.component.scss'],
})
export class CookingStoryPostComponent implements OnInit {
  recipe;
  isActive: boolean;
  image: string;
  @Input() set post(posts) {
    if (posts) {
      this.recipe = posts;

      if (posts.image) {
        this.image = posts.image;
      }
    }
  }
  @Input() set activated(data) {
    this.isActive = data;
  }
  @Input() ready?: boolean;
  @Input() last?: boolean;
  @Input() slide?: boolean;
  @Input() suggest?: boolean;
  @Input() showLike?: boolean = true;
  @Input() showPlay?: boolean = true;
  @Input() showTitle?: boolean = true;
  @Input() showName?: boolean = true;
  @Input()
  showFridge?: boolean = true;
  @Input() ratio: string = '1:1';
  @Input() width: number;
  @Input() height: number;
  @Input() kitchen: boolean = false;
  constructor(private recipeService: RecipeService) {}

  ngOnInit(): void {}
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
}
